module.exports = __webpack_public_path__ + "img/9788982738715.b1d2b48b.jpg";